export interface OrganizationEnvironment {
  readonly id?: string;
  readonly name?: string;
}

export declare const keySetType: {
  readonly KEY_TYPE_AES: 'KEY_TYPE_AES';
  readonly KEY_TYPE_TDES: 'KEY_TYPE_TDES';
  readonly UNSPECIFIED: 'UNSPECIFIED';
};
export type KeySetType = (typeof keySetType)[keyof typeof keySetType];

export interface OrganizationEnvironmentKeyset {
  readonly environmentId: string;
  readonly environmentName: string;
  readonly id: string;
  readonly name: string;
  readonly type: KeySetType;
}
export interface OrganizationEnvironmentKeysetResponse {
  readonly keysets: OrganizationEnvironmentKeyset[];
}

export enum OrganizationEnvironmentErrorType {
  ASSIGN_ENVIRONMENT = 'assignEnvironment',
  DELETE_ENVIRONMENT = 'deleteEnvironment',
  UPDATE_KEYSETS = 'updateKeysets',
}
